"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.eggheadAxios = exports.convertkitAxios = void 0;
var axios_1 = __importDefault(require("axios"));
var config_1 = require("@skillrecordings/config");
exports.convertkitAxios = axios_1["default"].create({
    baseURL: config_1.CONVERTKIT_BASE_URL
});
exports.eggheadAxios = axios_1["default"].create({
    baseURL: config_1.AUTH_DOMAIN
});
axios_1["default"].interceptors.request.use(function (config) {
    var authToken = typeof localStorage !== 'undefined'
        ? localStorage.getItem(config_1.ACCESS_TOKEN_KEY)
        : null;
    var defaultHeaders = authToken
        ? {
            Authorization: "Bearer ".concat(authToken),
            'X-SITE-CLIENT': config_1.AUTH_CLIENT_ID
        }
        : { 'X-SITE-CLIENT': config_1.AUTH_CLIENT_ID };
    var headers = __assign(__assign({}, defaultHeaders), config.headers);
    return __assign(__assign({}, config), { headers: headers });
}, function (error) {
    return Promise.reject(error);
});
exports["default"] = axios_1["default"];
